<template>
    <div class="d-flex justify-content-center align-items-center">
        <a @click.prevent="showModal()" class="btn w-100">{{button}}</a>
        <cat-uxo-modal v-if="modalVisible" @close="hideModal()">
            <!--            @todo convert into a component -->
            <div v-if="errors" class="errors mb-2">
                <template v-for="(item) in errors">
                    <template v-if="Array.isArray(item)">
                        <div v-for="(error) in item" class="error">{{error}}</div>
                    </template>
                    <template v-else>
                        <div class="error">{{item}}</div>
                    </template>
                </template>
            </div>
            <h2 class="text-center t-orange" slot="header">You’re contributing to {{contributionModel.name}}</h2>
            <form slot="body" method="POST" class="form form-register d-flex flex-column justify-content-center">
                <div class="columns">
                    <div class="column is-full">
                        <div class="field" :class="{ 'has-error': $v.form.contribution_text.$error }">
                            <label class="label mb-1" for="contributionText">Add your text contribution below*</label>
                            <div class="control">
                                    <textarea id="contributionText" name="contribution_text" class="textarea"
                                              v-model.trim="$v.form.contribution_text.$model"></textarea>
                            </div>
                            <div class="error" v-if="$v.$dirty && $v.form.contribution_text.$error">
                                {{getErrorMessage($v.form.contribution_text)}}
                            </div>
                        </div>
                    </div>
                </div>
                <!-- @todo convert to component -->
                <div class="columns">
                    <div class="column is-full">
                        <div class="field">
                            <label class="label mb-1">Upload your images and files here</label>
                        </div>
                        <div class="field position-relative mb-4">
                            <div class="upload">
                                <div class="control">
                                    <div class="upload__select p1 t-dark-grey lh-reset bg-white px-1 px-sm-2 py-2">
                                        <file-upload
                                            id="fileUpload"
                                            class="file-upload"
                                            extensions="gif,jpg,jpeg,png,webp,pdf"
                                            accept="image/png,image/gif,image/jpeg,image/webp,application/pdf,text/csv,text/plain,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                            :multiple="true"
                                            :size="1024 * 1024 * 10"
                                            v-model="files"
                                            @input-filter="inputFilter"
                                            @input-file="inputFile"
                                            ref="upload">
                                            Choose files
                                        </file-upload>
                                    </div>
                                </div>
                                <div class="control">
                                    <button class="btn btn-upload" @click.prevent="$refs.upload.$children[0].$el.click()">
                                        Choose Files
                                    </button>
                                </div>

                                <div class="upload__files mt-4" v-if="files.length">
                                    <div class="t-navy lh-lg mb-1">Files to upload</div>
                                    <ul class="files t-navy rows">
                                        <li class="file odd row px-1 px-sm-3 py-12px t-navy w-100"
                                            v-for="(file, index) in files"
                                            :key="file.id">
                                            <div class="d-flex w-100">
                                                <div class="column p-0 file__name fs-18 py-12px">{{file.name}}</div>
                                                <div class="column p-0 file__btn text-right">
                                                    <a class="btn btn-ghost btn-small w-100 p-1"
                                                       @click.prevent="confirmDelete(file, index)"
                                                       v-scroll-to="{el: '#confirmDelete',offset: -120}">Delete</a>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="file row px-1 px-sm-3 py-12px t-navy w-100" v-if="showConfirm">
                                            <div class="d-flex w-100 align-items-center" id="confirmDelete">
                                                <div class="column is-8 font-weight-light p-0 py-12px">
                                                    Are you sure you want to delete <strong>{{fileToDelete.name}}</strong>?
                                                </div>
                                                <div class="column p-0 buttons text-right">
                                                    <a class="btn btn-ghost btn-small btn-small--navy w-100 p-1 mr-sm-2 mb-2 mb-sm-0"
                                                       @click.prevent="keepFile()">Keep</a>
                                                    <a class="btn btn-ghost btn-small w-100 p-1"
                                                       @click.prevent="deleteFile()">Delete</a>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field mx-auto">
                    <button v-if="!loading" type="submit" class="btn btn-form" @click.prevent="submit">Add your contribution</button>
                    <pulse-loader v-if="loading" :loading="true" :color="'#E57722'" :size="'20px'"></pulse-loader>
                </div>
            </form>
        </cat-uxo-modal>
    </div>
</template>

<script>
    import MixinModal from '@/js/mixins/modal';
    import {axiosApi, axiosWeb} from "@/js/axios";
    import {required} from 'vuelidate/lib/validators';
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
    import {mapActions, mapGetters, mapState} from "vuex";
    import FileUpload from 'vue-upload-component';
    import vueScrollto from 'vue-scrollto';

    Vue.use(vueScrollto);

    export default {
        name: "CatUxoContribute",
        props: {
            button: {
                type: String,
                required: false,
                default: 'Contribute Information'
            },
            user: {
                type: Object,
                required: true,
            },
            contributionType: {
                type: Number,
                default: 2
            },
            contributionModel: {
                type: Object,
                required: true
            }
        },
        mixins: [MixinModal],
        components: {
            FileUpload,
            PulseLoader,
        },
        data: function () {
            return {
                form: {
                    contributor: this.user,
                    files: '',
                    contribution_text: '',
                },
                contribution: null,
                added: false,
                errors: [],
                files: [],
                uploadedFiles: [],
                loading: false,
                showConfirm: false,
                fileToDelete: null,
                fileToDeleteIndex: null,
            }
        },
        methods: {
            ...mapActions('contribution', [
                'fetchHazardContributions',
            ]),
            submit() {
                let $this = this;
                $this.$v.form.$touch();

                if ($this.$v.form.$invalid) return;

                $this.errors = [];

                // Display the loading on the button
                $this.loading = true;

                // Append hazard to the request
                $this.form.contribution_model_id = $this.contributionModel.id;
                $this.form.contribution_type = $this.contributionType;

                // Add the contribution
                return axiosApi.post(`/api/v3/contribution/store`, $this.form).then(response => {
                    $this.contribution = response.data;
                    let endPoint = process.env.MIX_APP_URL + `/api/v1/upload?folder=contributions&id=${$this.contribution.id}&user=${$this.user.id}`;
                    this.files.forEach(function (e) {
                        e.postAction = endPoint
                    });

                    let fileUpload = this.$refs.upload;
                    fileUpload.active = true;

                    if ($this.files.length === 0) {
                        this.fetchHazardContributions({
                            hazardId: this.contributionModel.id,
                            page: 1,
                            contributionType: this.contributionType
                        }).then((contributions) => {
                            this.loading = false;
                            this.hideModal();
                        });
                    }
                }).catch((error) => {
                    $this.loading = false;

                    if (error.response.status === 422) {
                        $this.errors = error.response.data.errors;
                    }

                    if (error.response.status === 500) {
                        $this.errors.push(error.response.data);
                    }
                })
            },
            inputFilter(newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    // Add a file

                    // Filter system files or hide files
                    if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                        return prevent()
                    }

                    // Filter php html js file
                    // php html js
                    if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                        return prevent()
                    }
                }
            },
            inputFile(newFile, oldFile) {
                if (newFile && oldFile && !newFile.active && oldFile.active) {
                    if (newFile.xhr) {
                        if (newFile.success) {
                            let uploadedFile = {};
                            uploadedFile.name = newFile.name;
                            uploadedFile.type = newFile.type;
                            uploadedFile.folder = 'contributions';
                            uploadedFile.hazardId = this.contributionModel.id;
                            uploadedFile.contributionId = this.contribution.id;

                            this.uploadedFiles.push(uploadedFile);
                        }

                        //  Get the response status code
                        if (this.$refs.upload.uploaded) {

                            // Save the paths to the database
                            this.saveHazardsAssets().then(() => {
                                this.fetchHazardContributions({
                                    hazardId: this.contributionModel.id,
                                    page: 1,
                                    contributionType: this.contributionType
                                }).then((contributions) => {
                                    this.loading = false;
                                    this.hideModal();
                                });
                                this.loading = false;
                            })
                        }
                    }
                }
            },
            confirmDelete(file, index) {
                this.fileToDelete = file;
                this.fileToDeleteIndex = index;
                this.showConfirm = true;
            },
            keepFile() {
                this.showConfirm = false;
                this.fileToDelete = null;
                this.fileToDeleteIndex = null;
            },
            deleteFile() {
                this.files.splice(this.fileToDeleteIndex, 1);
                this.showConfirm = false;
            },
            saveHazardsAssets() {
                return new Promise((resolve) => {
                    return axiosApi.post(`/api/v3/contribution/assets/store`, this.uploadedFiles).then(response => {
                        return resolve();
                    }).catch((error) => {
                        this.loading = false;

                        if (error.response.status === 500) {
                            this.errors.push('Contribution has been added but some files may not have been uploaded');
                        }
                    })
                })
            },
        },
        computed: {
            ...mapState('hazards', [
                'hazard',
            ]),
            ...mapGetters('form', [
                'getErrorMessage'
            ]),
            rules() {
                return {
                    contribution_text: {
                        required
                    },
                }
            },
        },
        validations() {
            return {
                form: this.rules
            }
        },
        mounted() {
        }
    }
</script>
<style lang="scss" scoped>
    .btn {
        width: 100%;
        min-width: rem(160px);
    }

    .file {
        &:nth-child(even) {
            background: $c-light-grey;
        }

        &:nth-child(odd) {
            background: $c-white;
        }
    }

    .buttons .btn {
        min-width: rem(88px);
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/shared/Contribute.vue